import { render, staticRenderFns } from "./ClientManagmentWebSite.vue?vue&type=template&id=b565b062&"
import script from "./ClientManagmentWebSite.vue?vue&type=script&lang=js&"
export * from "./ClientManagmentWebSite.vue?vue&type=script&lang=js&"
import style0 from "./ClientManagmentWebSite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports